module.exports = __webpack_public_path__ + "static/media/MICHELL AUDIO REVOLVE TURNTABLE.4e245018.png";